import React from 'react';
import { Card } from 'react-bootstrap';

const FieldsWrapper = (props) => {
  return (
    <Card className={`table-card-style`}>
      <Card.Header className="table-card-header-style">
        <Card.Title className="d-flex gap-3 align-items-center">
          Polja
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <label>Tipovi polja</label>
        {props.children}
      </Card.Body>
    </Card>
  );
};

export default FieldsWrapper;
